module.exports = __webpack_public_path__ + "img/13.60257768.png";